
  import cloudflareRuntime$t8pGJZ01Y_R43Wr83_9l57U3KxsPTmZkyfR1gfkGYmk from '/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
import ipxRuntime$ndnshkJ2bRU5zvPkxcFQhmvH2AqIztmJ1oAwnQXYS1o from '/data/gitlab-runner/builds/mbtSuhfSy/0/spilnu/frontend/spinking-dk/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 414,
    "md": 768,
    "lg": 1024,
    "xl": 1366,
    "2xl": 1536,
    "xs": 360,
    "xxl": 1920
  },
  "presets": {
    "gameservice": {
      "baseURL": "https://media.platego.io"
    },
    "local": {
      "baseURL": "/"
    },
    "heroDev": {
      "baseURL": "https://stage.spinking.dk"
    },
    "heroStage": {
      "baseURL": "https://stage.spinking.dk"
    },
    "heroProd": {
      "baseURL": "https://www.spinking.dk"
    }
  },
  "provider": "ipx",
  "domains": [
    "media.platego.io",
    "stage.spinking.dk"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['cloudflare']: { setup: cloudflareRuntime$t8pGJZ01Y_R43Wr83_9l57U3KxsPTmZkyfR1gfkGYmk, defaults: {"baseURL":"https://media.platego.io","modifiers":{"quality":"64"}} },
  ['ipx']: { setup: ipxRuntime$ndnshkJ2bRU5zvPkxcFQhmvH2AqIztmJ1oAwnQXYS1o, defaults: {} }
    }
  }
